export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_10.bc2a0b83.jpg";